import Comments from "@mui/icons-material/Comment";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import { red } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import { get, includes } from "lodash";
import React from "react";
import KMSwitch from "../../../common/js/components/KMSwitch";
import SaveAndExitButton from "../../../common/js/components/SaveAndExitButton";

const PageToolbar = styled("div")({
    padding: "10px 0px",
    backgroundColor: "#fafafa",
    position: "sticky",
    top: "70px",
    margin: "0 0 20px 0",
    zIndex: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
});

const ProgressDiv = styled("div")({
    textAlign: "center",
    width: "5em",
    display: "inline-block",
});

const ToolbarButtons = styled("div")({
    display: "flex",
    alignItems: "center",
});

const DeleteButton = styled(Button)({
    backgroundColor: red[500],
    color: "white",
    "&:hover": {
        backgroundColor: red[800],
    },
});

const StyledCommentsButton = styled(Button)({
    color: "black",
});

const AppraisalCompToolbar = (props) => {
    const {
        deal,
        deleteOutsideCompDialog,
        disableInputs,
        elementsSaving,
        handleConfidential,
        handleDeleteOutsideComp,
        handleDisplayDeleteDialog,
        numComments,
        saveAndExitOutsideOrAppraisalComp,
        saveOutsideOrAppraisalComp,
        submitOutsideOrAppraisalComp,
        toggleComments,
        userProfile,
        history,
    } = props;

    const handleDeleteAppraisalComp = async (dealKey) => {
        const result = await handleDeleteOutsideComp(dealKey);
        if (result.success) {
            history.push("/comps");
        }
    };

    const handleSubmitOutsideOrAppraisalComp = async (callback, skipRequiredValidation, submitStatus, compType) => {
        const result = await submitOutsideOrAppraisalComp(callback, skipRequiredValidation, submitStatus, compType);
        if (result.success) {
            history.push("/comps");
        }
    };

    const handleSaveAndExitOutsideOrAppraisalComp = async (compType) => {
        const result = await saveAndExitOutsideOrAppraisalComp(compType);
        if (result.success) {
            history.push("/comps");
        }
    };

    return (
        <PageToolbar>
            <div>
                <h2 className="page-title">
                    {deal.compStatus === "Appraisal Draft" ? "Create Appraisal Comp" : "Appraisal Comp"}
                </h2>
                <p className="page-subtitle">
                    {deal.propertyType} {deal.transactionType}
                </p>
            </div>
            <div>
                <ToolbarButtons>
                    <div>
                        <KMSwitch
                            checked={deal.confidentialFlg}
                            onChange={(e) => handleConfidential("confidentialFlg", e.target.checked)}
                            value={deal.confidentialFlg}
                            disabled={disableInputs}
                            label="Confidential"
                        />
                    </div>
                    {(includes(
                        ["dataAdmin", "dataEntry", "researchAdmin", "research", "appraiser"],
                        userProfile.role
                    ) ||
                        userProfile.user === get(deal, "auditCreatedBy", null)) && (
                        <div>
                            {elementsSaving.outsideCompDelete ? (
                                <ProgressDiv>
                                    <CircularProgress size={20} />
                                </ProgressDiv>
                            ) : (
                                <DeleteButton variant="contained" onClick={() => handleDisplayDeleteDialog(true)}>
                                    Delete Comp
                                </DeleteButton>
                            )}
                        </div>
                    )}
                    {deal.compStatus !== "Appraisal Draft" && (
                        <div>
                            <StyledCommentsButton disabled={Boolean(!deal.dealKey)} onClick={toggleComments}>
                                <Comments /> Comments ({numComments})
                            </StyledCommentsButton>
                        </div>
                    )}
                    <div>
                        {elementsSaving.saveAndExit ? (
                            <ProgressDiv>
                                <CircularProgress size={20} color="primary" />
                            </ProgressDiv>
                        ) : (
                            <React.Fragment>
                                <SaveAndExitButton
                                    onSave={() => saveOutsideOrAppraisalComp("appraisal")}
                                    onSaveAndExit={() => handleSaveAndExitOutsideOrAppraisalComp("appraisal")}
                                    disabled={disableInputs}
                                />
                            </React.Fragment>
                        )}
                    </div>
                    <div>
                        {deal.compStatus === "Appraisal Draft" &&
                            (elementsSaving.submit ? (
                                <ProgressDiv>
                                    <CircularProgress size={20} color="primary" />
                                </ProgressDiv>
                            ) : (
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => handleSubmitOutsideOrAppraisalComp(null, false, "Appraisal")}
                                    disabled={disableInputs}
                                >
                                    Submit
                                </Button>
                            ))}
                    </div>
                </ToolbarButtons>
            </div>
            <Dialog open={deleteOutsideCompDialog.open} maxWidth="xs" aria-labelledby="confirmation-dialog-title">
                <DialogTitle id="confirmation-dialog-title">Delete Appraisal Comp?</DialogTitle>
                <DialogContent>
                    Are you sure you want to permanently delete this appraisal comp? Appraisal comps cannot be recovered
                    once they have been deleted.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleDisplayDeleteDialog(false)} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={() => handleDeleteAppraisalComp(deal.dealKey)} color="primary">
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        </PageToolbar>
    );
};

export default AppraisalCompToolbar;
